import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';
import { GetItemsRequest, GetItemsResponse } from '../../types';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { MicroserviceRequest } from '../../../../utils/request/microservice.request';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';

export class CompanyFilterDashboardDataProvider extends GzSingleSelectComplexBaseDataProvider {
  static async getCompanyById(companyId: string): Promise<any> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Company',
        method: 'getCompanyById',
        payload: {
          companyId: companyId,
        },
      });

      if (!response.success || !response.data) {
        throw new Error('Unable to get company for filter');
      }

      return response.data;
    } catch (e) {
      throw new Error(e);
    }
  }

  static async getCompanyNameById(companyId: string): Promise<string> {
    try {
      const company = Application.Main.getUserCompany();
      if (company.id === companyId) {
        return company.name;
      }

      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Company',
        method: 'getCompanyById',
        payload: {
          companyId: companyId,
        },
      });

      if (!response.success || !response.data.name) {
        throw new Error('Unable to get company name for filter');
      }

      return response.data.name;
    } catch (e) {
      throw new Error(e);
    }
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await MicroserviceRequest.makeRequest<GetCompaniesRequest, GetCompaniesResponse>(
        'ProtectedEntities',
        'getCompaniesWithCount',
        {
          limit: request.limit,
          params: {
            includeOnlyWithCompaniesAccess: true,
            includeOwnCompanyWithAnyNetworkAccess: true,
          },
        }
      );

      return {
        items: response.targets.map(({ companyId, companyName }) => ({ value: companyId, label: companyName })),
        totalItemsCount: response.totalCount,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await MicroserviceRequest.makeRequest<GetCompaniesRequest, GetCompaniesResponse>(
        'ProtectedEntities',
        'getCompaniesWithCount',
        {
          page: request.page,
          limit: request.limit,
          companyName: request.searchValue,
          params: {
            includeOnlyWithCompaniesAccess: true,
            includeOwnCompanyWithAnyNetworkAccess: true,
          },
        }
      );

      return {
        items: response.targets
          ? response.targets.map(({ companyId, companyName }) => ({ value: companyId, label: companyName }))
          : [],
        totalItemsCount: response.totalCount,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
